// extracted by mini-css-extract-plugin
export default {"container":"aside_search_snippet_header-module__container--2wsw0","title":"aside_search_snippet_header-module__title--3RX45"};